import React from 'react';
import ReactDOM from 'react-dom';
import SelectModalTabs from './tabs'
import SelectModalResult from './result'
import {Input} from 'mkui-fd'
import './style'

const Search = Input.Search;
export default class SelectModalLayout extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.modalElement = null
    this.modalElementRef = React.createRef()
  }

  static defaultProps = {
    root: document.createElement('div'),
    bodyEle: document.getElementsByTagName('body')[0],
    prefixCls: "mkui-modal"
  }

  componentDidMount(){

  }

  onSearch(value){
    const {onSearch} = this.props
    onSearch(value)
  }

  open(){
    this.openModal()
  }

  openModal(){
    const { root, bodyEle, prefixCls, className, title, children, tips, onSearch } = this.props
    bodyEle.appendChild(root);
    this.modalElement = (
      <div>
        <div className={`${prefixCls}-mask`}/>
        <div className={`${prefixCls}-wrap`}>
          <div className={`${prefixCls} ${className} ${prefixCls}-layout`} ref={this.modalElementRef}>
            <div className={`${prefixCls}-content`}>
              <button className={`${prefixCls}-close`} onClick={()=>this.onCancel()}>
                <span className={`${prefixCls}-close-x`}>
                  <i className={`mkicon mkicon-close ${prefixCls}-close-icon`}/>
                </span>
              </button>
              <div className={`${prefixCls}-header`}>
                <div className={`${prefixCls}-title`}>{title}</div>
                {onSearch?<Search placeholder="input search text" onSearch={value => this.onSearch(value)} style={{ width: '100%' }}/>: null}
              </div>
              <div className={`${prefixCls}-body`}>
                {children}
              </div>
              {tips?<div className={`${prefixCls}-tips ${tips && tips.length? 'show':''}`}>
                {tips.forEach((tip)=(<div className={`${prefixCls}-tip`}>{tip}</div>))}
              </div>: null}

              <div className={`${prefixCls}-footer`}>
                <div>
                  <button type="button" className="mkui-btn" onClick={()=>this.onCancel()}><span>取 消</span></button>
                  <button type="button" className="mkui-btn mkui-btn-primary" onClick={()=>this.onConfirm()}><span>确 定</span></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )

    ReactDOM.render(this.modalElement, root)
    this.modalElementRef.current.style.transform = 'scale(1)'
  }

  closeModal() {
    const { root, bodyEle } = this.props
    this.modalElementRef.current.style.transform = 'scale(0.3)'
    setTimeout(() => {
      ReactDOM.unmountComponentAtNode(root)
      bodyEle.removeChild(root)
    },400)
  }

  onCancel() {
    this.closeModal()
    const {onCancel} = this.props
    if (onCancel) {
      onCancel()
    }
  }

  onConfirm(){
    this.closeModal()
    const {onConfirm} = this.props
    if(onConfirm){
      onConfirm()
    }
  }

  render(){
    return null
  }
}

SelectModalLayout.Tabs = SelectModalTabs
SelectModalLayout.Result = SelectModalResult
